import { Checkbox } from '@homeexchange/design';
import React from 'react';
import i18n from '../../../../i18n';
export var Location = function (_a) {
    var values = _a.values, onChange = _a.onChange;
    return (React.createElement(Checkbox, { label: i18n.t('home:feature-eco-public-transit-access'), value: "public-transit-access", message: i18n.t('search:filters.location.public_access.description'), onChange: onChange, checked: values.includes('public-transit-access'), name: "amenities" }));
};
